<template>
    <div class="wrapper">
            <section class="login-content">
                <div class="container">
                    <div class="row align-items-center justify-content-center height-self-center">
                        <div class="col-lg-8">
                            <div class="card auth-card">
                                <div class="card-body p-0">
                                    <div class="d-flex align-items-center auth-content">
                                        <div class="col-lg-8 align-self-center">
                                            <div class="p-3">
                                                <h2 class="mb-2">Mot de passe oublié</h2>
                                                <p></p>
                                                
                                                <form @submit.prevent="submit">
                                                    <div class="single-form">
                                                        Entrez votre adresse e-mail
                                                    </div>
                                                    <div class="single-form d-flex align-items-center">
                                                        <input
                                                        type="email"
                                                        placeholder="e-mail"
                                                        v-model="formlog.email"
                                                        required
                                                        class="form-control col-lg-8"
                                                        />
                                                        &nbsp;&nbsp;&nbsp;
                                                        <button class="form-control main-btn d-block col-lg-3">OK</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 content-right">
                                            <img src="/assets/images/yele.gif" class="img-fluid image-right" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="vld-parent">
            <loading :active.sync="isLoading" 
            :can-cancel="true" 
            :is-full-page="fullPage"></loading>
         </div>
        </div>
</template>
  
  <script>
  
  import axios from 'axios'
  import Swal from 'sweetalert2'
  import router from '@/router'
  //import store from '@/store'
  export default {
    name: "recovery",
    data() {
      return {
        formlog: {
          email: '',
        },
        
      };
    },
    components: {},
    mounted(){
    },
    methods: {
      submit() {
        let app=this
        axios.post(
             'https://enrolements-backend.yelemoney.com/api/auth/recovery',
            app.formlog
          )
          .then(function (reponse) {
            console.log("rep", reponse.data);
            if (reponse.data.status == true) {
              Swal.fire({title: 'Note',
              text:'Veuillez consulter votre boîte mail.',
              icon:'info',
              showConfirmButton: false,
              timer:1000
            });
            } else {
              Swal.fire({title: 'Erreur',
              text: reponse.data.message,
              icon:'error',
              showConfirmButton: false,
              timer:3000
            });
            }
            router.push('/')
          })
          .catch((error) => {
            
            Swal.fire({title: 'Erreur',
              text: error.data.message,
              icon:'error',
              showConfirmButton: false,
              timer:3000
            });
            console.log(error);
          });
      },
    },
  };
  </script>
  